import { Row, Col, Badge } from 'react-bootstrap';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import type { GolfEventSummaryWithCaptain } from '../types/api.types';

interface TourOverviewProps {
  lstEvents: GolfEventSummaryWithCaptain[];
}

// Helper to get team badge class name
const getTeamBadgeClass = (teamWinner: string | null): string => {
  if (teamWinner == null) return 'team-none';
  return teamWinner === 'USA' ? 'team-usa' : 'team-eur';
};

// Helper to get team result text
const getTeamResultText = (teamWinner: string | null, teamRetained: boolean | null): string => {
  if (teamWinner == null) return 'n/a';
  return `${teamWinner} ${teamRetained ? 'retain' : 'win'}`;
};

// Component for rendering team result badge and captain
const TeamResult = ({ event }: { event: GolfEventSummaryWithCaptain }) => (
  <>
    <Badge className={getTeamBadgeClass(event.teamWinner)}>
      {getTeamResultText(event.teamWinner, event.teamRetained)}
    </Badge>
    {event.teamWinner != null && <span>{` Cap: ${event.winningCaptain || ''}`}</span>}
  </>
);

// Component for rendering individual winner
const IndividualWinner = ({ event }: { event: GolfEventSummaryWithCaptain }) => (
  <Link to={`/members/${event.indWinnerID}`}>
    <img src={`/assets/${event.indWinnerID}.jpg`} height="45px" alt="" />
    <span>{` ${event.indWinnerFirstName || ''} ${event.indWinnerSurname || ''}`}</span>
  </Link>
);

export default function TourOverview({ lstEvents }: TourOverviewProps) {
  if (lstEvents == null) {
    return <p>No Data</p>;
  }

  const eventRows = lstEvents.map((event) => (
    <tr key={event.id}>
      <td style={{ verticalAlign: 'middle' }}>
        <Link to={`/summer-tour/${event.id}`}>{event.date ? DateTime.fromISO(event.date).year : ''}</Link>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{event.venueName}</td>
      <td style={{ verticalAlign: 'middle', padding: '1px' }}>
        <IndividualWinner event={event} />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <TeamResult event={event} />
      </td>
    </tr>
  ));

  return (
    <Row>
      <Col md={12}>
        <table className="table">
          <thead>
            <tr>
              <th>Year</th>
              <th>Venue</th>
              <th>Tournament Winner</th>
              <th>Ryd-Her Cup Result</th>
            </tr>
          </thead>
          <tbody>{eventRows}</tbody>
        </table>
      </Col>
    </Row>
  );
}
